import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,  
  TableCell,  
  Typography,
} from '@material-ui/core';

import { Archive } from '@material-ui/icons';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';


import PropTypes from 'prop-types';

import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawerTechnical from '../../fields/menuDrawerTechnical';
import SpinnerLoading from '../../feedback/spinnerLoading';
import TranslationWarning from '../../modals/translationWarning';

import FormDetailsTechnical from './formDetailsTechnical';


import { getProgramConfiguration, getProgramXls } from '../../../utils/comms';
import { downloadProgramTexts } from '../../../utils/helpers';

import translations from '../../../languages/i18n';
import { addProgramTranslations }  from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import programConfigurationStyles from '../../../styles/programConfigurationStyles';

import { sectionTitle, customOptionsTableStyles, tableTitle } from '../../../styles/formElementsStyles';


// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ProgramConfigurationTechnical({ lang, handleChangeLang }) {
  const bgColors = customOptionsTableStyles();
  const classesTable = tableTitle();
  const classesProgConfig = programConfigurationStyles();

  const sessionContext = useContext(SessionContext);

  const [infoReady, setInfoReady] = useState(false);
  const [programConfiguration, setProgramConfiguration] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showTranslationWarning, setShowTranslationWarning] = useState(false);

  const { idProgram } = useParams();

  const history = useHistory();

  const handleCloseDialog = () => {
    setShowTranslationWarning(false);
  };

  useEffect(() => {
    const getProgramConfigurationFromServer = async () => {
      setShowLoading(true);
      const response = await getProgramConfiguration(idProgram, sessionContext.userToken);  

      if (response.status === 200) { // Tenim llistat
        try {
          await addProgramTranslations(idProgram, sessionContext.userToken);
        } catch (error) {
          setShowTranslationWarning(true);
        }   
        setProgramConfiguration(response.data.programConfiguration);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
      setShowLoading(false);
      setInfoReady(true);
    };
    getProgramConfigurationFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const gotoFormVariables = (formName) => {
    history.push(`/technical/listFormVariables/${formName}/${idProgram}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      <TranslationWarning handleClose={handleCloseDialog} message={translations['_errorInternalCommonTranslationsNotAvailable']} open={showTranslationWarning} title={translations['_alert']} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawerTechnical type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <div className={classes.body}>
        {infoReady && (
          <Grid container direction='column' spacing={2}>
            {/* ----------------------- Fila 0 ----------------------- */}
            <Grid item xs={12}>
              {/* <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} /> */}
            </Grid>
            {/* ----------------------- Fila 1 ----------------------- */}
            <Grid item className={sectionTitleStyle.root}>
              <Grid container justify='space-between' spacing={2}>
                <Grid item>
                  <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_program']}: {programConfiguration.sharedId}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* ----------------------- Fila 2 ----------------------- */}
            <Grid item>
              <Grid container justify='center' spacing={2}>
                <Grid item xs={8}>
                  <Typography variant='h6' component='div'>{translations['_numPatientVars']} {programConfiguration.numPatientVars || translations['_infoNotAvailable']}</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant='h6' component='div'>{translations['_downloadProgramSpreadsheet']}
                    <IconButton size='medium' onClick={() => getProgramXls(idProgram, sessionContext.userToken)}>
                      <Archive />
                    </IconButton>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant='h6' component='div'>{translations['_downloadProgramTexts']}
                    <IconButton size='medium' onClick={() => downloadProgramTexts(programConfiguration.sharedId, idProgram, sessionContext.userToken)}>
                      <Archive />
                    </IconButton>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* ----------------------- Fila 3 ----------------------- */}
            {programConfiguration.computedVars.length > 0 && <Grid item>
              <Grid container justify='center' spacing={2}>
                <Grid item xs={8}>
                  <Typography variant='h6' component='div'>{translations['_computedVars']}:</Typography>
                </Grid>
                <Grid item xs={8}>
                {
                  programConfiguration.computedVars.map((computedVar)=> (
                  <Typography component='div' key={computedVar}><Typography component='span' style={{fontWeight: 'bold'}}>{computedVar}</Typography>: {translations[computedVar]}</Typography>
                  ))
                }
                </Grid>
              </Grid>
            </Grid>}
            {/* ----------------------- Fila 4 ----------------------- */}
            {programConfiguration.feedbackVars.length > 0 && <Grid item>
              <Grid container justify='center' spacing={2}>
                <Grid item xs={8}>
                  <Typography variant='h6' component='div'>{translations['_feedbackVars']}:</Typography>
                </Grid>
                <Grid item xs={8}>
                {
                  programConfiguration.feedbackVars.map((feedbackVar)=> (
                  <Typography component='div' key={feedbackVar}><Typography component='span' style={{fontWeight: 'bold'}}>{feedbackVar}</Typography>: {translations[feedbackVar]}</Typography>
                  ))
                }
                </Grid>
              </Grid>
            </Grid>}
            {/* ----------------------- Fila 5 ----------------------- */}
            <Grid item>
              <Grid container justify='center' spacing={2}>
                <Grid item xs={8}>
                  {
                    programConfiguration.events.map((event)=> (
                      <TableContainer component={Paper} key={event.desc} className={classesProgConfig.eventTable}>
                        <Table aria-label='program configuration table'>
                          <TableHead>
                            <TableRow className={bgColors.tableRowHeaderBgColor}>
                              <TableCell colSpan={2} className={classesProgConfig.eventTableCell0}>
                                <Typography variant='h5' component='div' className={classesTable.title}>{translations['_eventType'].toUpperCase()}: {event.desc}</Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell className={classesProgConfig.eventTableCell1}><strong>{translations['_managedIn']}</strong></TableCell>
                              <TableCell className={classesProgConfig.eventTableCell2}>{event.managedBy.toString()}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classesProgConfig.eventTableCell1}><strong>{translations['_allowRepeat']}</strong></TableCell>
                              <TableCell className={classesProgConfig.eventTableCell2}>{event.allowRepeat ? translations['_yes']: translations['_no']}</TableCell>
                            </TableRow>

                            {
                              event.actions && event.actions.length > 0 && event.actions.map((act, index)=> (
                                <TableRow key={`${act.action}_${index}`}>
                                  <TableCell className={classesProgConfig.eventTableCell1}><strong>{act.action}:</strong></TableCell>
                                  <TableCell className={classesProgConfig.eventTableCell2}>
                                    {
                                      act.forms && act.forms.map((form, subindex) => (<FormDetailsTechnical key={`${form}_${index}_${subindex}`} programConfiguration={programConfiguration} formIdentificator={form} handleShowVariables={(formName)=> gotoFormVariables(formName)} />))
                                    }
                                  </TableCell>
                                </TableRow>
                              ))
                            }
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ))
                  }
                </Grid>                
              </Grid>
            </Grid>
          </Grid>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ProgramConfigurationTechnical);

// Indica i controla els props que se han de passar al component
ProgramConfigurationTechnical.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};
